// ENTITY fr.gestionpial.pial.dto.DashboardAlerteDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class DashboardAlerteDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.DashboardAlerteDTO';

  type: string | null = '';
  message: string | null = '';
  idRef: number | null = 0;
  idAbsenceAesh: number | null = 0;

  constructor(init?:Partial<DashboardAlerteDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.DashboardAlerteDTO'] = DashboardAlerteDTO;

fields['fr.gestionpial.pial.dto.DashboardAlerteDTO']  = {
    type: 'java.lang.String',
    message: 'java.lang.String',
    idRef: 'java.lang.Integer',
    idAbsenceAesh: 'java.lang.Integer'
};
